<template>
  <div>
    <div>
      <van-search background="#ffffff" shape="round" placeholder="请输入地点名称" v-model="searchNodeText"></van-search>
      <div class="node-title">目前可选择{{(nodeType==1||nodeType==3)?'上':'下'}}车点</div>
      <van-tree-select
        style="height: auto;"
        height="auto" 
           
        :items="nodeList"
        :main-active-index="mainActiveIndex"
        :active-id="activeId"
        v-on:navclick="onStartNavClick"
        v-on:itemclick="onStartItemClick"
        
      ></van-tree-select>
    </div>
    <div
      v-show="isShowLoading"
      style="position:fixed;top:30%;left:50%;margin-left:-20px;z-index:100000000000;"
    >
      <van-loading color="orange" size="40px" />
    </div>
  </div>
</template>

<script>
import { Search, TreeSelect } from "vant";
import C2Pin from "c2pin";



export default {
  components: {
    [Search.name]: Search,
    [TreeSelect.name]: TreeSelect
  },  
  data() {
    return {
      nodeType: 1, //站点选择类型(start:上车点 end:下车点)
      nodeFilter:"",
      searchNodeText: "",
      stratNodeGID: this.$route.query.startNodeGID,
      arriveNode: this.$route.query.arriveNode,
      arriveDate: this.$route.query.schDate,
      topNodeCityList:[],
      nodeList: [],
      orignNodeList: [],    
      mainActiveIndex: 0,
      activeId: 0,
      isShowLoading: false
    };
  },
  methods: {
    showLoading: function(flag) {
      this.isShowLoading = flag;
    },
    onStartNavClick: function(index) {
      this.mainActiveIndex = index;
    },
    // 上车点 站点选择
    onStartItemClick: function(data) {
      this.activeId = data.id;
      let node = {
                gid: data.id,
                name: data.text.replace(/所有出发站|所有到达地/g,''),
                DataSourceCode: data.DataSourceCode
      };
      node.type = this.nodeType;
      this.$store.dispatch("setNode", node);
      this.$router.go(-1);
    },
    // 站点前台模糊查询
    nodeQuery: function(data) {
      //data = $.trim(data)
     
      if (!data) {
        this.nodeList = JSON.parse(JSON.stringify(this.orignNodeList));
        return;
      }
      data = data.replace(/^\s+|\s+$|\s+/g, "");
      let list = [];

      for (let i = 0; i < this.orignNodeList.length; i++) {
        let item = this.orignNodeList[i];
        let regList = this.$utils.searchByRegExp(data, item.children, "text");
        if (regList.length > 0) {
          let option = {
            children: regList,
            text: item.text
          };
          list.push(option);
        }
      }
      this.nodeList = list;
    },
    //获取站点数据
    getNodeList() {
      let that = this;
      that.showLoading(true);
  
      let params = {};
      let url ="";
      let type=parseInt(this.nodeType);

      switch (type) {
        case 1:
          url= this.$api.API_StartNodeQuery
         break;
         case 2:
          url=this.$api.API_ArrivalNodeQuery
          params = { StartNodeGID: this.stratNodeGID,nodeName:this.nodeFilter};
          break;
         case 3:
          url=this.$api.API_StartNodeQueryByDstNode
          params = { DstNode: this.arriveNode,SchDate:this.arriveDate};
          break;
        default:
      
          break;
      }

      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          that.showLoading(false);
          console.log(res);
          if (res.success) {
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].CityAndDis =
                res.data[i].CityName +
                (res.data[i].DistrictName
                  ? "(" + res.data[i].DistrictName + ")"
                  : "");

              res.data[i].allDivision =
                res.data[i].CityName +
                res.data[i].DistrictName +
                (res.data[i].CountrySide ? res.data[i].CountrySide : "");

              res.data[i].CityPin = C2Pin.firstChar(
                res.data[i].CityName.substring(0, 1)
              )
                .substring(0, 1)
                .toUpperCase();

              if (res.data[i].DistrictName) {
                res.data[i].DistrictPin = C2Pin.firstChar(
                  res.data[i].DistrictName.substring(0, 1)
                )
                  .substring(0, 1)
                  .toUpperCase();
              }
            }

            that.fullStartNodeList = res.data; // 所有的站点（如果url存在LineGID或LineGIDList参数，在nodeListHandle方法重新赋值）

            let list = this.$utils.groupBy(res.data, function(item) {
             
              return [item.CityAndDis];
            });

            that.nodeListHandle(list);
          }
        })
        .catch(err => {
          that.showLoading(false);
          console.log(err);
          // this.$dialog.alert({
          //   title: "提示",
          //   message: err
          // });
        });
    },
    // 站点数据处理
    nodeListHandle: function(data) {
      let type = this.nodeType;
      console.log(data);
      let list = [];
      
      function sortNode(a, b) {
        return a.NodeName.localeCompare(b.NodeName, "zh");
      }

      for (let i = 0; i < data.length; i++) {
        data[i].sort(sortNode);
      }

      for (let i = 0; i < data.length; i++) {
        let dataItem = data[i];
        if (dataItem.length < 1) {
          continue;
        }

        let item = { text: dataItem[0].CityAndDis||'#', children: [] };
        
        if(dataItem.length>1 && type == 2){
          if(dataItem[0].CityAndDis){
            item.children.push( {
              text: dataItem[0].CityAndDis+`所有`+((this.nodeType==1||this.nodeType==3)?'出发站':'到达地'),
              id: dataItem[0].CityAndDis
            });
          }
        }

        for (let j = 0; j < dataItem.length; j++) {
         
          let nodeEnabledCount=0
          if(dataItem[j].NodeEnabled){
            nodeEnabledCount++
          }

         let option = {
            text: dataItem[j].NodeName,
            id: dataItem[j].GID,
            disabled:!dataItem[j].NodeEnabled,
            DataSourceCode: dataItem[j].DataSourceCode
          };

          if (type == 1) {
            option.NodeArray = JSON.parse(dataItem[j].ArrivalNodeArray);
          }
          if (type == 2) {
            option.NodeArray = JSON.parse(dataItem[j].StartNodeArray);
          }

          item.children.push(option);
        
        }

        // 只有children存在值，才push到list里，避免发生只存在城市名，点进去没站点的情况
        if (item.children.length > 0) {
          list.push(item);
        }

     
      }


      //按城市名排序
      function sortCity(a, b) {
        return a.text.localeCompare(b.text, "zh");
      }
      list.sort(sortCity);

     //按城市名置顶站点信息列表
     if(type==2){
        let topCityList=this.topNodeCityList
        let topItemList=[]
        
        for (let i = 0; i < topCityList.length; i++) {
          let topCity=topCityList[i];
          let topItems= this.$utils.searchByRegExp(topCity, list, "text")
          
          if(topItems.length>0){
            let topItem =this.$utils.cloneObj(topItems[0]);
            let topItemIndex=-1;
          
            for (let j = 0; j < list.length; j++) {
              let nodeItem = list[j];
              if(nodeItem.text==topItem.text)
              {
                  topItemIndex=j;
                  break;
              }        
            }
            list.splice(topItemIndex,1)
            topItemList.push(topItem)    
          }
        }

        list=[].concat(topItemList,list)
     }

      this.nodeList = list;
      this.orignNodeList = JSON.parse(JSON.stringify(list));
    }
  },
  created() {
  
    this.nodeType = this.$route.query.nodeType ? this.$route.query.nodeType : 1;
    this.nodeFilter=this.$route.query.nodeFilter ? this.$route.query.nodeFilter : "";
    this.topNodeCityList=this.$route.query.topNodeCityList?this.$route.query.topNodeCityList.split(','):[]
    this.getNodeList();
  },
  mounted() {},
  watch: {
    // 监听上车点搜索内容变化
    searchNodeText(newVal) {
      this.mainActiveIndex = 0;
      this.nodeQuery(newVal);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color:#f58c0c;
}

/deep/.van-sidebar-item--select::before {
    background-color: #ff976a
}


.van-tree-select {
  position: absolute;
  top: 100px;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.van-tree-select__nav {
  background-color: #f3f3f3;
  text-align: center;
  font-weight: 400;
}

.van-tree-select__nav .van-tree-select__nitem {
  line-height: 1;
  padding: 15px 9px 15px 15px;
  overflow: inherit;
  white-space: inherit;
  font-weight: 600;
  font-size:18px
  
}

.van-tree-select__content {
  background-color: #fafafa;
  padding-left: 5px;
  padding-right: 5px;
}

.van-tree-select__item {
  background-color: #fff;
  margin-bottom: 3px;
  /* text-indent: .2rem; */
  border-radius: 3px;
  line-height: 1;
  overflow: inherit;
  white-space: inherit;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: 600;
  font-size:17px
  
}
.van-tree-select__selected {
  right: 5px;
}

.van-tree-select__nitem--active {
  background-color: #fafafa;
}

.van-tree-select__item--active {
  color: #f5840c;
}

.van-tree-select__nitem--active::after {
  background-color: #f5840c;
}

.node-title {
  line-height: 44px;
  background-color: #fff;
  color: #333;
  border-top: 1px solid #ebedf0;
  text-indent: 15px;
}
</style>
